export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-dollar-feeac8a34d1febe795f103111a6eb81a.svg";